<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
            <div class="search_con m_flex_box flex_vc">我的办理</div>
            <span class="newAdd" @click="jumpPage">新增入网</span>
          </div>
          <!-- <p class="header_address m_flex_box flex_vc" @click="jumpPage">
            <span>新增入网</span>
          </p>
        </div> -->
        </div>
      </div>
    </div>
    <div class="fixed_top"></div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list finished-text="没有更多了" @load="onLoad" :finished="finished">
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="" />
        </div>
        <div
          class="inner bor_b"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpDetail(item)"
        >
          <div class="row">
            <p class="m_flex_box">
              企业名称：<span>{{ item.corpName ? item.corpName : "-" }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              企业地址：<span>{{
                item.corpAddress ? item.corpAddress : "-"
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              <!-- 办理类型：<span>{{item.applyType==0 ? item.applyType== : "-"}}</span> -->
              办理类型：<span v-show="item.applyType == 0">入网申请</span>
              <span v-show="item.applyType == 1"
                >变更申请-企业资质相关变更</span
              >
              <span v-show="item.applyType == 2"
                >变更申请-营业执照相关变更</span
              >
              <span v-show="item.applyType == 3">变更申请-固话或区域变更</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              提交日期：<span>{{ item.createDate | capitalize }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              审核状态：
              <span v-show="item.process == 1">草稿</span>
              <span v-show="item.process == 2">待审核</span>
              <span v-show="item.process == 3">未通过</span>
              <span style="display: flex" v-show="item.process == 4"
                >已通过-待交件
                <van-icon
                  size="0.3rem"
                  name="question-o"
                  color="#ff0000"
                  @click.stop="clickNotify"
                />
              </span>
              <span v-show="item.process == 5">已归档</span>
            </p>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      // loading: false,
      finished: false,
      list: [],
      timer: null,
    };
  },
  mounted() {},
  filters: {
    capitalize: function (value) {
      if (!value) {
        return "-";
      } else {
        return value.substring(0, value.length - 2);
      }
    },
  },
  methods: {
    clickNotify() {
      Dialog.alert({
        messageAlign:"left",
        title: "提示",
        message: "请您携带待交件,及时进行线下交件,否则入网业务无法最终归档。待交件要求请参考《入网须知》或《变更须知》,交件方式如下：<br>1、现场交件，地址：徐州市鼓楼区坝子街9号中和大厦1513室。<br>2、邮寄交件，地址：徐州市鼓楼区坝子街9号中和大厦1513室，收件人张琨，电话83601286。",
      }).then(() => {
        // on close
      });
    },
    onRefresh() {
      // this.loading = true;
      this.finished = false;
      this.onLoad(1);
    },
    goback() {
      this.$router.go(-1);
    },
    jumpDetail(item) {
      if (item.process == 1) {
        if (item.applyType == 0) {
          this.$router.push({
            path: "/editEnterprise",
            query: { applyId: item.applyId },
          });
        } else if (item.applyType == 1) {
          this.$router.push({
            path: "/qualificationChange",
            query: { applyId: item.applyId },
          });
        } else if (item.applyType == 2) {
          this.$router.push({
            path: "/licenseChange",
            query: { applyId: item.applyId },
          });
        } else {
          this.$router.push({
            path: "/areaChange",
            query: { applyId: item.applyId },
          });
        }
      } else {
        if (item.applyType == 0) {
          this.$router.push({
            path: "/checkEnterprise",
            query: {
              applyId: item.applyId,
            },
          });
        } else if (item.applyType == 1) {
          this.$router.push({
            path: "/checkQualificationChange",
            query: { applyId: item.applyId },
          });
        } else if (item.applyType == 2) {
          this.$router.push({
            path: "/checkLicenseChange",
            query: { applyId: item.applyId },
          });
        } else {
          this.$router.push({
            path: "/checkAreaChange",
            query: { applyId: item.applyId },
          });
        }
      }
    },
    jumpPage() {
      this.$router.push({
        path: "/addEnterprise",
      });
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$test
          .post(
            "spf/corpinfoapply/getListByPhone",
            {},
            {
              headers: {
                xzfpftoken: sessionStorage.getItem("userId") || "",
              },
            }
          )
          .then((res) => {
            if (type) {
              this.isLoading = false;
            }
            if (res.code == "000") {
              this.list = res.result;
              this.finished = true;
            } else if (res.code == "003") {
              this.$toast(res.msg);
              this.$router.replace({
                path: "/enterpriseAccess",
              });
            } else {
              this.finished = true;
              this.$toast(res.msg);
            }
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.fixed_top {
  padding-top: 1.2rem;
}
.header_address {
  padding: 0.1rem 0.2rem;
  border-radius: 0.1rem;
  background-color: #f2f6ff;
  color: #2f72f5;
  font-size: 0.28rem;
  font-weight: 600;
  cursor: pointer;
  &.white {
    &:after {
      border-color: #fff transparent transparent transparent;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.bg_gray {
  min-height: 100vh;
  background-color: #f5f5f5;
  .newAdd {
    padding: 0.1rem 0.15rem;
    font-size: 0.2rem;
    border-radius: 0.1rem;
    border: 1px solid #007fff;
    color: #007fff;
    position: absolute;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
  }
}
.inner {
  padding: 0.24rem 0.24rem;
  background-color: #fff;
}
.top {
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.2rem;
  margin-bottom: 0.12rem;
  h5 {
    font-size: 0.26rem;
    font-weight: 800;
    max-width: 70%;
  }
  p {
    font-size: 0.24rem;
    span {
      color: #2f72f5;
    }
  }
}
.row {
  &:last-child {
    padding-bottom: 0;
  }
  padding-bottom: 0.12rem;
  p {
    line-height: 0.36rem;
    color: #808080;
    font-size: 0.24rem;
    span {
      max-width: 80%;
      color: #101010;
    }
  }
}
.bor_b {
  border-bottom: 0.1rem solid #f5f5f5;
}
</style>